module.exports = __webpack_public_path__ + "img/201705-2-930x1024.f035cfdf.jpeg";